'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.botTypingMessageReceived = undefined;

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _startBotTyping = require('./startBotTyping');

var botTypingMessageReceived = exports.botTypingMessageReceived = function botTypingMessageReceived(message, threadId) {
  return function (dispatch) {
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    dispatch((0, _startBotTyping.startBotTyping)(threadId, senderId));
  };
};